import { ExtraIdValue, MeasurementValue } from "@/common/apis/dtos";
import { getUserPreferences, UserPreferences } from '@chr/online-shared-microsite-core';

const EMPTY_VALUE = ' - ';

export const formatStringValues = (values: string[] | undefined): string => {
  if (!values || values.length === 0) {
    return EMPTY_VALUE;
  }
  return values.map(x => x.trim()).filter(x => x).join(', ');
};

export const formatMeasurementValues = (
  measurementValues: MeasurementValue,
  unitOfMeasure: string
): string => {
  const value = unitOfMeasure === 'standard'
    ? measurementValues.standard
    : measurementValues.metric;
  
  return value ?? EMPTY_VALUE;
};

export const getDisplayValue = (extraIdValues: ExtraIdValue | undefined): string => {
  if (!extraIdValues) {
    return EMPTY_VALUE;
  }

  // Priority: measurement values over string values
  if (extraIdValues.measurementValues) {
    const systemPreference = getUserPreferences();
    const unitOfMeasure = systemPreference?.unitOfMeasure ?? 'standard'; //fallback to standard if undefined
    return formatMeasurementValues(extraIdValues.measurementValues, unitOfMeasure);
  }

  return formatStringValues(extraIdValues.values);
};